import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NOTIFICATION_EVENTS } from '@shared/common';

@Injectable({
	providedIn: 'root',
})
export class NotificationSettingsService {
	constructor(private http: HttpClient) {}

	public getDetail(eventType, objId) {
		return this.http.get(`/api/notification/detail?eventType=${eventType}&objId=${objId}`);
	}

	public getSettings() {
		return this.http.get('/api/notification/setting/group');
	}

	public getUserSettings() {
		return this.http.get('/api/notification/setting/user');
	}

	public updateUserSettings(data: any) {
		return this.http.post('/api/notification/setting/update', data);
	}

	/*
	 * notif: notif detail
	 * isMobile: mobile platform
	 * redirectInfo: more info from notification detail
	 */
	public getRedirectInfo(notif, isMoblie, redirectInfo = null) {
		var output;
		switch (notif.Event) {
			case NOTIFICATION_EVENTS.Sound: //0,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: false // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.Created_New_Job: //1
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? `/jobs/detailsJobs/${redirectInfo.Job_Id}`
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}`; // redirect link
				break;
			case NOTIFICATION_EVENTS.JobEstimate_Event_ToDoTask_Journal: //2,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: false // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.Calendar_Event: //3,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: false // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.New_Email: //4,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: false // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.Residential_Commercial_Contact: //5,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: false // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.New_Employee_Contact: //6,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: false // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.EquipmentEntry_Assignment: //7,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: false // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.Total_Job_By_Day: //8,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: false // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.Total_Estimates_By_Day: //9,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: false // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.Total_Sales_By_Day: //10,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: false // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.New_Timeline_Task: //11,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? `/task/${redirectInfo.Task_Id}`
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}?type=TaskDetail&taskid=${redirectInfo.Task_Id}#taskandwo`; // redirect link
				break;
			case NOTIFICATION_EVENTS.New_Work_Order: //12,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? `/workorder/${redirectInfo.Work_Order_Id}/edit/detail`
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}?type=WorkOrderDetail&woid=${redirectInfo.Work_Order_Id}#taskandwo`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Timeline_Payment: //13,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: false // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.User_Near_Job_Add: //14,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? `/workorder/${redirectInfo.Work_Order_Id}/edit/detail`
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}?type=WorkOrderDetail&woid=${redirectInfo.Work_Order_Id}#taskandwo`; // redirect link
				break;
			case NOTIFICATION_EVENTS.User_Leave_Job_Add: //15,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? `/workorder/${redirectInfo.Work_Order_Id}/edit/detail`
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}?type=WorkOrderDetail&woid=${redirectInfo.Work_Order_Id}#taskandwo`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Job_Info_Update: //16,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? `/jobs/detailsJobs/${redirectInfo.Job_Id}#job-info`
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Work_Order_Update: //17,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? `/workorder/${redirectInfo.Work_Order_Id}/edit/detail`
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}?type=WorkOrderDetail&woid=${redirectInfo.Work_Order_Id}#taskandwo`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Timeline_Task_Update: //18,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? `/task/${redirectInfo.Task_Id}`
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}?type=TaskDetail&taskid=${redirectInfo.Task_Id}#taskandwo`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Work_Order_Completed: //19,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: false // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.Phase_Completed: //20,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: true // false if not implement
						: isMoblie
							? ``
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}#timeline`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Stage_Completed: //21,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: true // false if not implement
						: isMoblie
							? ``
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}#timeline`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Phase_Update: //22,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: false // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.Stage_Update: //23,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: false // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.Time_Off_Request: //24,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? `/hours/time-off/${redirectInfo.Time_Off_Tab}/detail?id=${redirectInfo.Time_Off_Id}`
							: `/admin/time-off?type=${redirectInfo.Time_Off_Type}&tab=${redirectInfo.Time_Off_Tab}&id=${redirectInfo.Time_Off_Id}`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Job_Customer_Update: //26,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: false // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.Job_Date_Update: //27,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? `/jobs/detailsJobs/${redirectInfo.Job_Id}#job-dates`
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}#job-dates`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Int_Part_Assigned: //28,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: true // false if not implement
						: isMoblie
							? `/jobs/detailsJobs/${redirectInfo.Job_Id}#participant`
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}#participant`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Timeline_Task_Remove: //30,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.WO_Comment_Add: //32,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? `/workorder/${redirectInfo.Work_Order_Id}/edit/detail?section=3`
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}?type=WorkOrderDetail&woid=${redirectInfo.Work_Order_Id}#taskandwo`; // redirect link
				break;
			case NOTIFICATION_EVENTS.WO_Photo_Add: //33,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: `/jobs/detailsJobs/${redirectInfo.Job_Id}?photoId=${notif.Object_Id}#photostream`; // redirect link
				break;
			case NOTIFICATION_EVENTS.WO_Document_Add: //34,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? `/workorder/${redirectInfo.Work_Order_Id}/edit/detail?documentId=${notif.Object_Id}`
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}?type=WorkOrderDetail&woid=${redirectInfo.Work_Order_Id}&documentId=${notif.Object_Id}#taskandwo`; // redirect link
				break;
			case NOTIFICATION_EVENTS.WO_Document_Update: //35,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? `/workorder/${redirectInfo.Work_Order_Id}/edit/detail?documentId=${notif.Object_Id}`
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}?type=WorkOrderDetail&woid=${redirectInfo.Work_Order_Id}&documentId=${notif.Object_Id}#taskandwo`; // redirect link
				break;
			case NOTIFICATION_EVENTS.PS_Photo_Add: //36,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: `/jobs/detailsJobs/${redirectInfo.Job_Id}?photoId=${notif.Object_Id}#photostream`; // redirect link
				break;
			case NOTIFICATION_EVENTS.PS_Photo_Comment_Add: //37,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: `/jobs/detailsJobs/${redirectInfo.Job_Id}?photoId=${redirectInfo.Photo_Id}#photostream`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Accounting_Document_Add: //38,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: false // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.Accounting_Estimate_Add: //39,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: true // false if not implement
						: isMoblie
							? ``
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}?section=estimate#accounting`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Accounting_Estimate_Revise: //60,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: true // false if not implement
						: isMoblie
							? ``
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}?section=estimate#accounting`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Accounting_Payment_Add: //40,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: true // false if not implement
						: isMoblie
							? ``
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}?section=payment#accounting`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Ready_Invoice_Created: //41,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: true // false if not implement
						: isMoblie
							? ``
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}#accounting`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Job_Journal_Add: //42,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: `/jobs/detailsJobs/${redirectInfo.Job_Id}?journalId=${notif.Object_Id}#journal`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Job_Journal_Update: //43,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: `/jobs/detailsJobs/${redirectInfo.Job_Id}?journalId=${notif.Object_Id}#journal`; // redirect link
				break;
			case NOTIFICATION_EVENTS.User_Forgot_Clock_Out: //46,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: false // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.Today_Assignee_Near_Job_Add: //48,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? `/workorder/${redirectInfo.Work_Order_Id}/edit/detail`
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}?type=WorkOrderDetail&woid=${redirectInfo.Work_Order_Id}#taskandwo`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Today_Assignee_Leave_job_Add: //49,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? `/workorder/${redirectInfo.Work_Order_Id}/edit/detail`
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}?type=WorkOrderDetail&woid=${redirectInfo.Work_Order_Id}#taskandwo`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Assignee_Forgot_Clock_Out: //50,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: false // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.Int_Part_Update: //51,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: true // false if not implement
						: isMoblie
							? ``
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}#participant`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Work_Order_Delete: //52,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.Assigned_To_New_WO: //53,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? `/workorder/${redirectInfo.Work_Order_Id}/edit/detail`
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}?type=WorkOrderDetail&woid=${redirectInfo.Work_Order_Id}#taskandwo`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Assigned_To_New_Task: //54,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? `/task/${redirectInfo.Task_Id}`
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}?type=TaskDetail&taskid=${redirectInfo.Task_Id}#taskandwo`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Assigned_To_Existing_WO: //55,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? `/workorder/${redirectInfo.Work_Order_Id}/edit/detail`
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}?type=WorkOrderDetail&woid=${redirectInfo.Work_Order_Id}#taskandwo`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Assigned_To_Existing_Task: //56,
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? `/task/${redirectInfo.Task_Id}`
							: `/jobs/detailsJobs/${redirectInfo.Job_Id}?type=TaskDetail&taskid=${redirectInfo.Task_Id}#taskandwo`; // redirect link
				break;
			case NOTIFICATION_EVENTS.PS_Photo_Update: //57,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: false // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
			case NOTIFICATION_EVENTS.Contact_Update: //58,
				output =
					redirectInfo == null
						? isMoblie
							? false
							: true // false if not implement
						: isMoblie
							? ``
							: `/crm/${redirectInfo.Contact_CRM_Type}/${redirectInfo.Contact_Id}`; // redirect link
				break;
			case NOTIFICATION_EVENTS.Time_Off_Update_Status: //59
				output =
					redirectInfo == null
						? isMoblie
							? true
							: true // false if not implement
						: isMoblie
							? `/hours/time-off/${redirectInfo.Time_Off_Tab}/detail?id=${redirectInfo.Time_Off_Id}`
							: `/admin/time-off?type=${redirectInfo.Time_Off_Type}&tab=${redirectInfo.Time_Off_Tab}&id=${redirectInfo.Time_Off_Id}`; // redirect link
				break;
			default:
				output =
					redirectInfo == null
						? isMoblie
							? false
							: false // false if not implement
						: isMoblie
							? ``
							: ``; // redirect link
				break;
		}
		return output;
	}

	public getEventIcon(event) {
		var icon = './assets/image/notification/notif_job.png';
		switch (event) {
			// Group type: Jobs
			// case NOTIFICATION_EVENTS.<eventEnumName>://<eventId
			case NOTIFICATION_EVENTS.Created_New_Job: //1,
			case NOTIFICATION_EVENTS.New_Timeline_Task: //11,
			case NOTIFICATION_EVENTS.New_Work_Order: //12,
			case NOTIFICATION_EVENTS.User_Near_Job_Add: //14,
			case NOTIFICATION_EVENTS.User_Leave_Job_Add: //15,
			case NOTIFICATION_EVENTS.Job_Customer_Update: //26,
			case NOTIFICATION_EVENTS.Job_Info_Update: //16,
			case NOTIFICATION_EVENTS.Job_Date_Update: //27,
			case NOTIFICATION_EVENTS.Int_Part_Assigned: //28,
			case NOTIFICATION_EVENTS.Timeline_Task_Update: //18,
			// removed //29
			case NOTIFICATION_EVENTS.Timeline_Task_Remove: //30,
			// removed //31
			case NOTIFICATION_EVENTS.Work_Order_Update: //17,
			case NOTIFICATION_EVENTS.WO_Comment_Add: //32,
			case NOTIFICATION_EVENTS.WO_Photo_Add: //33,
			case NOTIFICATION_EVENTS.WO_Document_Add: //34,
			case NOTIFICATION_EVENTS.WO_Document_Update: //35,
			case NOTIFICATION_EVENTS.Phase_Completed: //20,
			case NOTIFICATION_EVENTS.Stage_Completed: //21,
			case NOTIFICATION_EVENTS.PS_Photo_Add: //36,
			case NOTIFICATION_EVENTS.PS_Photo_Comment_Add: //37,
			case NOTIFICATION_EVENTS.Accounting_Document_Add: //38,
			case NOTIFICATION_EVENTS.Accounting_Estimate_Add: //39,
			case NOTIFICATION_EVENTS.Accounting_Payment_Add: //40,
			case NOTIFICATION_EVENTS.Ready_Invoice_Created: //41,
			case NOTIFICATION_EVENTS.Job_Journal_Add: //42,
			case NOTIFICATION_EVENTS.Job_Journal_Update: //43,
			case NOTIFICATION_EVENTS.User_Forgot_Clock_Out: //46,
			// removed //47
			case NOTIFICATION_EVENTS.Today_Assignee_Near_Job_Add: //48,
			case NOTIFICATION_EVENTS.Today_Assignee_Leave_job_Add: //49,
			case NOTIFICATION_EVENTS.Assignee_Forgot_Clock_Out: //50,
			case NOTIFICATION_EVENTS.Int_Part_Update: //51,
			case NOTIFICATION_EVENTS.Work_Order_Delete: //52,
			case NOTIFICATION_EVENTS.Assigned_To_Existing_WO: //55,
			case NOTIFICATION_EVENTS.Assigned_To_Existing_Task: //56,
			case NOTIFICATION_EVENTS.Contact_Update: //58,
				icon = './assets/image/notification/notif_job.png';
				break;
			// Group type: Email
			// case NOTIFICATION_EVENTS.<eventEnumName>://<eventId
			// icon = "./assets/image/notification/notif_email.png";
			// break;
			// Group type: Calendar
			// case NOTIFICATION_EVENTS.<eventEnumName>://<eventId
			// icon = "./assets/image/notification/notif_calendar.png";
			// break;
			// Group type: CRM
			// case NOTIFICATION_EVENTS.<eventEnumName>://<eventId
			// icon= "./assets/image/notification/notif_crm.png";
			// break;
			// Group type: Equipment
			// case NOTIFICATION_EVENTS.<eventEnumName>://<eventId
			// icon = "./assets/image/notification/notif_equipment.png";
			// break;
			// Group type: User Profile
			// case NOTIFICATION_EVENTS.<eventEnumName>://<eventId
			// icon = "./assets/image/notification/notif_user_profile.png";
			// break;
			// Group type: "Notifications Settings",
			// case NOTIFICATION_EVENTS.<eventEnumName>://<eventId
			// icon = "./assets/image/notification/notif_notification_setting.png";
			// break;
			// Group type: Company Settings
			// case NOTIFICATION_EVENTS.<eventEnumName>://<eventId
			// icon = "./assets/image/notification/notif_company_setting.png";
			// break;
			// Group type: Employee Management
			// case NOTIFICATION_EVENTS.<eventEnumName>://<eventId
			// icon = "./assets/image/notification/notif_employee_management.png";
			// break;
			// Group type: Time Off
			// case NOTIFICATION_EVENTS.<eventEnumName>://<eventId
			case NOTIFICATION_EVENTS.Time_Off_Request: //24,
			case NOTIFICATION_EVENTS.Time_Off_Update_Status: //59
				icon = './assets/image/notification/notif_time_off.png';
				break;
			// Group type: unknow
			// case NOTIFICATION_EVENTS.<eventEnumName>://<eventId
			case NOTIFICATION_EVENTS.Sound: //0,
			case NOTIFICATION_EVENTS.JobEstimate_Event_ToDoTask_Journal: //2,
			case NOTIFICATION_EVENTS.Calendar_Event: //3,
			case NOTIFICATION_EVENTS.New_Email: //4,
			case NOTIFICATION_EVENTS.Residential_Commercial_Contact: //5,
			case NOTIFICATION_EVENTS.New_Employee_Contact: //6,
			case NOTIFICATION_EVENTS.EquipmentEntry_Assignment: //7,
			case NOTIFICATION_EVENTS.Total_Job_By_Day: //8,
			case NOTIFICATION_EVENTS.Total_Estimates_By_Day: //9,
			case NOTIFICATION_EVENTS.Total_Sales_By_Day: //10,
			case NOTIFICATION_EVENTS.Timeline_Payment: //13,
			case NOTIFICATION_EVENTS.Work_Order_Completed: //19,
			case NOTIFICATION_EVENTS.Phase_Update: //22,
			case NOTIFICATION_EVENTS.Stage_Update: //23,
			case NOTIFICATION_EVENTS.Job_Date_Update: //27,
			case NOTIFICATION_EVENTS.Int_Part_Assigned: //28,
			case NOTIFICATION_EVENTS.Assigned_To_New_WO: //53,
			case NOTIFICATION_EVENTS.Assigned_To_New_Task: //54,
			case NOTIFICATION_EVENTS.PS_Photo_Update: //57,
				// not define in group
				break;
		}
		return icon;
	}

	//#3659
	// GET api/notification/default/setting/list
	getDefaultNotifiParticipant() {
		return this.http.get(`/api/notification/default/setting/list`);
	}
	// POST api/notification/default/setting/update
	AddOrUpdateDefaultNotifiParticipant(data) {
		return this.http.post(`/api/notification/default/setting/update`, data);
	}
}
